import {
  EXPORT_CLEAR_STATE,
  FETCH_EXPORT_OPTIONS,
  FETCH_EXPORT_OPTIONS_SUCCESS,
  FETCH_EXPORT_OPTIONS_FAILURE, SHOW_EXPORT_DIALOG, HIDE_EXPORT_DIALOG,
} from '@Pages/RetroSynthesis/ExportRoute/constants';

export const initialState = {
  exportDialogIsShown: false,
  error: undefined,
  response: undefined,
  isLoading: false,
  isBusy: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case EXPORT_CLEAR_STATE:
      return { ...initialState };
    case FETCH_EXPORT_OPTIONS:
      return { ...state, isLoading: true };
    case HIDE_EXPORT_DIALOG:
      return { ...state, exportDialogIsShown: false };
    case SHOW_EXPORT_DIALOG:
      return { ...state, exportDialogIsShown: true, isBusy: action.payload };
    case FETCH_EXPORT_OPTIONS_SUCCESS:
      return { ...state, isLoading: false, response: action.payload, error: undefined };
    case FETCH_EXPORT_OPTIONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload, response: undefined };
    default :
      return state;
  }
}
